module.exports = __webpack_public_path__ + "img/au010.6ee34aba.jpg";